"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var Clipboard_1 = require("./Clipboard");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(Clipboard_1).default; } });
//# sourceMappingURL=index.js.map